import React, {Component} from 'react';

import {
	TEST_STEPS,
	TEST_STEPS_BY_ID,
	YOUTH_TEST_STEPS_BY_ID,
	CHILD_SCRNG_TEST_STEPS_BY_ID,
	CHILD_TEST_STEPS_BY_ID,
	Z_SCORE_OFFSET,
	Z_SCORE_MAX,
} from '../../../constants';
import classNames from 'classnames';

import roundWithDecimals from 'utils/roundWithDecimals';
import strings from 'utils/strings';

import normalDistributionImage from 'assets/kurve.png';

class Subtest extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	// eslint-disable-next-line complexity
	returnTestScores = (
		id,
		totalCorrect,
		testType,
		flag,
		zScore,
		tScore,
		scaledScore,
		standardScore
	) => {
		const valueByFlag = {
			zscore: zScore,
			tscore: tScore,
			scaledscore: scaledScore,
			standardScore: standardScore,
		};

		if (!Object.prototype.hasOwnProperty.call(valueByFlag, flag)) {
			return '';
		}

		const value = valueByFlag[flag];
		const decimals = flag === 'zscore' ? 2 : 0;

		const nCorrect = Number(totalCorrect);
		const isYouthFollowup = testType === 'youth-followup';
		const isBoundedId = id === 0 || id === 4;

		// Only apply the < / > formatting for youth-followup for ids 0 and 4
		if (isYouthFollowup && isBoundedId && Number.isFinite(nCorrect)) {
			const bounds = id === 0 ? [5, 17] : [62, 115];
			const [min, max] = bounds;

			if (nCorrect < min) {
				return `: < ${roundWithDecimals(value, decimals)}`;
			}
			if (nCorrect > max) {
				return `: > ${roundWithDecimals(value, decimals)}`;
			}
		}

		return `: ${roundWithDecimals(value, decimals)}`;
	};

	render() {
		const {subtest, type} = this.props;
		const {
			totalCorrect,
			id,
			zScore,
			percentile,
			tScore,
			scaledScore,
			standardScore,
			vars,
		} = subtest;

		const zScoreImageLabelWidth = 20.79;
		const zScoreImageRightPaddingWidth = 2.25;
		const zScoreChartWidth =
			100 - zScoreImageRightPaddingWidth - zScoreImageLabelWidth;

		let subtestInfo = null;
		switch (type) {
			case 'child':
				subtestInfo = CHILD_TEST_STEPS_BY_ID[id];
				break;
			case 'adult-screening':
				subtestInfo = TEST_STEPS_BY_ID[id];
				break;
			case 'youth-screening':
				subtestInfo = YOUTH_TEST_STEPS_BY_ID[id];
				break;
			case 'child-screening':
				subtestInfo = CHILD_SCRNG_TEST_STEPS_BY_ID[id];
				break;
		}

		const subtestQuestionCount = subtestInfo.questionCount;
		const subtestLabel = subtestInfo.label;

		let totalCorrectLabel;

		if (type === 'child' || type === 'child-experimental') {
			let myVars;
			if (vars) {
				myVars = JSON.parse(vars);
			}
			switch (id) {
				case 0: {
					totalCorrectLabel = strings.formatString(strings.testView.rattAvMojliga, totalCorrect, subtestQuestionCount);
					break;
				}
				case 3: {
					let totalErrors = 0;
					let duration = 0;
					if (myVars && myVars.duration) {
						duration = myVars.duration;
						totalErrors = myVars.totalErrors;
					}
					totalCorrectLabel = strings.formatString(strings.testView.anvandTidSekunderAntalFel, Math.round(duration / 1000), totalErrors);
					break;
				}
				case 4: {
					totalCorrectLabel = `${totalCorrect}  ${strings.testView.wordreadcorrectly}`;
					break;
				}
				case 5: {
					let totalCorrect = 0;
					let duration = 0;
					if (myVars && myVars.duration) {
						duration = myVars.duration;
						totalCorrect = myVars.totalCorrect;
					}
					totalCorrectLabel = strings.formatString(strings.testView.rattAv50MojligaPa, totalCorrect, Math.round(duration / 1000));
					break;
				}
				case 12: {
					totalCorrectLabel = `${totalCorrect}  ${strings.testView.wordreadcorrectly}`;
					break;
				}
				default: {
					totalCorrectLabel = `${totalCorrect} av ${subtestQuestionCount}`;
				}
			}
		} else if (type !== 'child' && type !== 'child-experimental') {
			if (subtestInfo.name === TEST_STEPS.SKRIVEHASTIGHET) {
				totalCorrectLabel = `${totalCorrect} ${strings.common.wordsperminute}`;
			} else {
				totalCorrectLabel = `${totalCorrect} av ${subtestQuestionCount}`;
			}
		}

		let updatedZScore;
		if (zScore < -4) {
			updatedZScore = -4;
		} else if (zScore > 4) {
			updatedZScore = 4;
		} else {
			updatedZScore = zScore;
		}

		const testZScorePercentage =
			(updatedZScore + Z_SCORE_OFFSET) / Z_SCORE_MAX;
		const testZChartBarLeft =
			zScoreImageLabelWidth + testZScorePercentage * zScoreChartWidth;

		return (
			<div className="sub-test" key={id}>
				<h3 className="sub-test__name">{subtestLabel}</h3>
				<div className="sub-test__scores">
					<div className="sub-test__col">
						<div className="lit-z-chart">
							<img
								className="lit-z-chart__figure"
								src={normalDistributionImage}
								alt={strings.common.normalDistributionAlt}
							/>
							<div
								className="lit-z-chart-bar"
								style={{
									left: `${testZChartBarLeft}%`,
								}}
							>
								<div
									className={classNames({
										'lit-z-chart-bar__fill': true,
										positive: zScore > 1,
										negative: zScore < -1,
									})}
								/>
							</div>
						</div>
					</div>

					<div className="sub-test__col">
						<h4 className="sub-test__heading">
							{strings.testView.overview}
						</h4>

						<div className="sub-test-horizontal-chart">
							{/* NEW: preserve \n in rawscore label */}
							<p
								className="sub-test__value"
								style={{whiteSpace: 'pre-line'}}
							>
								<strong>{strings.common.rawscore}</strong>
								{`: `}
								{totalCorrectLabel}
							</p>

							<p className="sub-test__value">
								<strong>{strings.common.zscore}</strong>
								{this.returnTestScores(
									id,
									totalCorrect,
									this.props.testType,
									'zscore',
									zScore,
									tScore,
									scaledScore,
									standardScore
								)}
							</p>

							{type !== 'youth-screening' && (
								<p className="sub-test__value">
									<strong>{strings.common.percentilescore}</strong>
									{`: `}
									{roundWithDecimals(percentile, 0)}
								</p>
							)}

							<p className="sub-test__value">
								<strong>{strings.common.tscore}</strong>
								{this.returnTestScores(
									id,
									totalCorrect,
									this.props.testType,
									'tscore',
									zScore,
									tScore,
									scaledScore,
									standardScore
								)}
							</p>

							{type != 'adult-screening' &&
								type !== 'child-screening' && (
									<p className="sub-test__value">
										<strong>{strings.common.scaledscore}</strong>
										{this.returnTestScores(
											id,
											totalCorrect,
											this.props.testType,
											'scaledscore',
											zScore,
											tScore,
											scaledScore,
											standardScore
										)}
									</p>
								)}

							{type != 'adult-screening' &&
								type !== 'child-screening' && (
									<p className="sub-test__value">
										<strong>{strings.common.standardpoang}</strong>
										{this.returnTestScores(
											id,
											totalCorrect,
											this.props.testType,
											'standardScore',
											zScore,
											tScore,
											scaledScore,
											standardScore
										)}
									</p>
								)}

							<p className="sub-test__value rating">
								{strings.testView.assessment}
								{zScore <= -1 && (
									<span className="sub-test__assessmentText">
										{strings.formatString(
											strings.testView.assessmentsubtestbelow,
											roundWithDecimals(zScore, 2),
											<span className="sub-test__nobBreakText">
												<em>{strings.common.under}</em>
											</span>
										)}
										<br />
										<span className="sub-test__nobBreakText">
											{strings.testView.theAverage}
										</span>
									</span>
								)}
								{zScore >= 1 && (
									<span className="sub-test__assessmentText">
										{strings.formatString(
											strings.testView.assessmentsubtestbelow,
											roundWithDecimals(zScore, 2),
											<em>{strings.common.over}</em>
										)}
										<br />
										<span className="sub-test__nobBreakText">
											{strings.testView.theAverage}
										</span>
									</span>
								)}
								{zScore < 1 && zScore > -1 && (
									<span className="sub-test__assessmentText">
										{strings.testView.assessmentsubtestnormal}
									</span>
								)}
							</p>
						</div>
					</div>

					{this.props.children}
				</div>
			</div>
		);
	}
}

export default Subtest;
